<ion-item-sliding lines="none" class="ion-no-margin">
	<ion-item lines="none" class="ion-no-margin ion-no-padding" (click)="selectCard()" data-cy="selectCard">
		<ion-card mode="ios" class="ion-no-margin" (click)="selectCard()" data-cy="selectCard">
			<ion-card-content>
				<ion-card-title *ngIf="cardData.title">
					<ion-grid class="ion-no-padding">
						<ion-row>
							<ion-col size="12">
								<ng-container *ngIf="cardData.title">{{ cardData.title }}</ng-container>
								<span *ngIf="cardData.secondTitle">{{ cardData.secondTitle }}</span>
							</ion-col>
						</ion-row>
					</ion-grid>
				</ion-card-title>

				<ng-container *ngIf="!cardData.isOriginalSample">
					<ion-badge class="qc">{{ 'entry.badges.qc' | translate }}</ion-badge>
				</ng-container>

				<ng-container *ngIf="cardData.isStandard">
					<ion-badge class="std">{{ 'entry.badges.std' | translate }}</ion-badge>
				</ng-container>

				<ion-grid class="ion-no-padding">
					<ion-row *ngFor="let property of cardData.properties | slice: 0 : rowLimit">
						<ion-col class="ion-text-start" size="6">{{ property.label }}</ion-col>
						<ion-col class="ion-text-start" size="6"
							>{{ property.value | formatEntryItem: property.valueType }}
						</ion-col>
					</ion-row>
				</ion-grid>
			</ion-card-content>
		</ion-card>
	</ion-item>
	<ion-item-options *ngIf="!isReadonlyMode" side="end" class="ion-no-border">
		<ng-container>
			<ion-item-option *ngIf="cardData.isOriginalSample" class="ion-no-border duplicate">
				<div>
					<ion-icon
						appThrottleButtonDirective
						[throttleTime]="2000"
						(eventTriggered)="createDup($event)"
						data-cy="createDup"
						class="ion-no-padding icon-Duplicate"
					></ion-icon>
					<ion-label>{{ 'entity.buttons.qc' | translate }}</ion-label>
				</div>
			</ion-item-option>
			<ion-item-option class="ion-no-border delete">
				<div>
					<ion-icon
						appThrottleButtonDirective
						[throttleTime]="2000"
						(eventTriggered)="deleteRecord($event)"
						data-cy="deleteRecord"
						class="ion-no-padding icon-Delete"
					></ion-icon>
					<ion-label>{{ 'entity.buttons.delete' | translate }}</ion-label>
				</div>
			</ion-item-option>
		</ng-container>
	</ion-item-options>
</ion-item-sliding>
